export class ScheduleTaskChecklist {
    checkListItemId: number;
    scheduleTaskId: number;
    sequence: number;
    description: string;
    completed: boolean;
}
